import { CampaignPostBulkPasteDialog } from '../../overlays/campaign-post-bulk-paste-dialog';
import { CampaignPostCsvImportDialog } from '../../overlays/campaign-post-csv-import-dialog';
import { StepSubsectionTitle } from '../../primitives';
import type { CampaignPostDraft } from '../../campaign-editor-types';
import { CampaignPostInputCanvas } from './campaign-post-input-canvas';
import { useCampaignPostBulkPaste } from './hooks';
import { useCampaignPostCsvImport } from './hooks';
import { useCampaignPostRows } from './hooks';
import { useCampaignPostValidation } from './hooks';

type Props = {
  campaignItemSlotLimit: number;
  draft: CampaignPostDraft;
  remainingSlots: number;
};

export function CampaignPostsSection({
  campaignItemSlotLimit,
  draft,
  remainingSlots,
}: Props) {
  const validation = useCampaignPostValidation({
    postItems: draft.postItems,
  });
  const postInputRows = useCampaignPostRows({
    postItems: draft.postItems,
    remainingSlots,
    setPostItems: draft.setPostItems,
  });
  const csvImport = useCampaignPostCsvImport({
    campaignItemSlotLimit,
    draftPostItems: validation.draftPostItems,
    remainingSlots,
    setPostItems: draft.setPostItems,
  });
  const bulkPaste = useCampaignPostBulkPaste({
    campaignItemSlotLimit,
    draftPostItems: validation.draftPostItems,
    remainingSlots,
    setPostItems: draft.setPostItems,
  });

  return (
    <section className="space-y-6">
      <div className="space-y-5">
        <div className="space-y-3">
          <StepSubsectionTitle title="Add post URLs" />
          <div className="flex flex-wrap items-center justify-end gap-3">
            <div className="flex flex-wrap items-center gap-3">
              <CampaignPostBulkPasteDialog
                onApplyBulkPaste={bulkPaste.applyPostBulkPaste}
                onGetBulkPastePreview={bulkPaste.getPostBulkPastePreview}
                remainingSlots={remainingSlots}
              />
              <CampaignPostCsvImportDialog
                onApplyCsvImport={csvImport.applyPostCsvImport}
                onDownloadTemplate={csvImport.downloadPostTemplate}
                onPreviewCsvImport={csvImport.previewPostCsvImport}
                remainingSlots={remainingSlots}
              />
            </div>
          </div>

          <CampaignPostInputCanvas rows={postInputRows} validation={validation} />
        </div>
      </div>
    </section>
  );
}
